import { useQuery } from "@tanstack/react-query";
import { designersApi } from "../api/designersApi";
import { designersKeys } from "../api/designersKeys";

export const useDesigners = (params) =>
  useQuery({
    queryKey: designersKeys.list(params),
    queryFn: () => designersApi.list(params),
  });
